import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AuthLayout from "../layout/AuthLayout";
import FullLayout from "../layout/FullLayout";
import PortalLayout from "../layout/PortalLayout";
import About from "../modules/about";
import WhatNew from "../modules/about/what-new";
import GrowthAgent from "../modules/ai-assist/growth-agent";
import HiringAgent from "../modules/ai-assist/hiring-agent";
import RecruitingAgent from "../modules/ai-assist/recruiting-agent";
import AuthLogin from "../modules/auth/login";
import ForgotPassword from "../modules/auth/login/forgot-password";
import ResetPassword from "../modules/auth/login/reset-password";
import SignUp from "../modules/auth/login/signup";
import Candidates from "../modules/candidates";
import BuildPipeline from "../modules/candidates/build-pipeline";
import CandidateView from "../modules/candidates/candidate-view";
import Coversheet from "../modules/coversheet/coversheet";
import CoverSheetCandidate from "../modules/coversheet/candidate";
import ResumeUpload from "../modules/coversheet/resume-upload";
import AgencyInformation from "../modules/crm/agency-information";
import Client from "../modules/crm/client-partner/client";
import RelationshipIntelligenceView from "../modules/crm/client-partner/crm-view";
import Vendor from "../modules/crm/client-partner/vendor";
import DynamicIntelligence from "../modules/dynamic-intelligence";
import Horizon from "../modules/home";
import Usermanual from "../modules/home/user-manual";
import BidManagement from "../modules/ignite/bid-management";
import JudicaTable from "../modules/ignite/judica";
import Judica from "../modules/ignite/judica/components";
import SowDraft from "../modules/ignite/judica/components/SowDraft";
import ProposalTableList from "../modules/ignite/proposal-generator/components/ProposalTableList";
import StepperComponent from "../modules/ignite/proposal-generator/components/SowStepperProposalGenerator";
import SowEnrichment from "../modules/ignite/sow-enrichment";
import Jobs from "../modules/jobs";
import CandidateScoring from "../modules/jobs/candidate-scoring";
import CreateJob from "../modules/jobs/create-job";
import ReviewJobPost from "../modules/jobs/create-job/components/ReviewJobPost";
import CreateNewJob from "../modules/jobs/create-job/create-new-job";
import EnrichJob from "../modules/jobs/create-job/enrich-job";
import JobKrystalPath from "../modules/jobs/job-krystal-path";
import JobsCandidate from "../modules/jobs/jobs-candidate";
import JobsCandidateCompare from "../modules/jobs/jobs-candidate-compare";
import JobsSummary from "../modules/jobs/jobs-summary";
import JobsView from "../modules/jobs/jobs-view";
import { default as JobsBoard } from "../modules/jobs/kanban-board";
import Submission from "../modules/jobs/submission";
import AccessTeamFit from "../modules/matches/access-team-fit";
import AccessTeamFitCreate from "../modules/matches/access-team-fit/access-team-fit-create";
import AccessTeamFitView from "../modules/matches/access-team-fit/access-team-fit-view";
import JigsawCandidateCompare from "../modules/matches/access-team-fit/jobs-candidate-compare";
import CandidateToJob from "../modules/matches/candidate-to-job";
import QuickMatch from "../modules/matches/quick-match";
import OnBoarding from "../modules/onboarding";
import AccountCreate from "../modules/organization-setup/account-create";
import CreateFailed from "../modules/organization-setup/creation-failed";
import PageNotFound from "../modules/organization-setup/page-not-found";
import PlanExpired from "../modules/organization-setup/plan-expired";
import SubscriptionExpired from "../modules/organization-setup/subscription-expired";
import TransactionStatus from "../modules/organization-setup/transaction-status";
import Permission from "../modules/permission";
import ReportDashBoard from "../modules/report-dashboard";
import ReviewProductivity from "../modules/reports/review-productivity";
import CreateCandidateResume from "../modules/resume-intelligence/create-candidate-resume";
import ProtectedRoute from "./ProtectedRoute";
// import BuildPipeline from "../modules/candidates/build-pipeline";
import BuyCredits from "../modules/credit";
import InterviewKit from "../modules/jobs/interview-kit";
import ReferenceCheck from "../modules/jobs/reference-check";
import ReferenceCheckViewDetails from "../modules/jobs/reference-check-view";
import ReferenceCheckDetails from "../modules/reference-check";

const MainRoutes = () => {
  const signUpData = useSelector((state) => state.layout.signUp);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (signUpData && signUpData?.success === false) {
      navigate("/creation-failed");
    }
  }, [signUpData]);

  const pathConditionCheck = () => {
    const locationPath = ["/agency-information", "/client", "/vendor"];
    const check = locationPath.some((p) => location.pathname.includes(p));
    let result = [""];
    if (check) {
      result = ["Recruiter"];
    }
    return result;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute restrictedTo={pathConditionCheck()}>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/auth/login" />} />
        {/* Home */}
        <Route path="/home" element={<Horizon />} />
        <Route path="/home/user-manual" element={<Usermanual />} />
        <Route
          path="/resume-intelligence/create-candidate-resume"
          element={<CreateCandidateResume />}
        />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/jobs-view" element={<JobsView />} />
        <Route path="/create-jobs" element={<CreateJob />} />
        <Route path="/enrich-job" element={<EnrichJob />} />
        <Route path="/create-new-job" element={<CreateNewJob />} />
        <Route path="/jobs/new-job" element={<ReviewJobPost />} />
        <Route path="/jobs/jobs-summary" element={<JobsSummary />} />
        <Route path="/jobs/jobs-candidate" element={<JobsCandidate />} />
        <Route
          path="/jobs/candidate/compare/:firstResumeId/:secondResumeId"
          element={<JobsCandidateCompare />}
        />
        <Route path="/jobs/submission" element={<Submission />} />
        <Route path="/job-krystal-path" element={<JobKrystalPath />} />
        <Route path="/jobs/jobs-board" element={<JobsBoard />} />̦
        <Route
          path="/jobs/jobs-view/candidate-scoring"
          element={<CandidateScoring />}
        />
        <Route
          path="/jobs/jobs-view/reference-check"
          element={<ReferenceCheck />}
        />
        <Route
          path="/jobs/jobs-view/reference-check-view"
          element={<ReferenceCheckViewDetails />}
        />
        {/* Candidates */}
        <Route path="/candidates" element={<Candidates />} />
        <Route path="/candidates/candidate-view" element={<CandidateView />} />
        <Route
          path="/candidates/candidate-view/candidate-scoring"
          element={<CandidateToJob />}
        />
        <Route path="/build-pipeline" element={<BuildPipeline />} />
        {/* Matches */}
        <Route path="/tools/quick-match" element={<QuickMatch />} />
        {/* CRM */}
        <Route path="/client" element={<Client />} />
        <Route path="/vendor" element={<Vendor />} />
        <Route path="/agency-information" element={<AgencyInformation />} />
        <Route
          path="/relationship-intelligence-view"
          element={<RelationshipIntelligenceView />}
        />
        <Route path="/sow-enrichment" element={<SowEnrichment />} />
        <Route path="/sow-enrichment/create-enrich" element={<SowDraft />} />
        <Route path="/judica" element={<JudicaTable />} />
        <Route path="/judica/judica-view" element={<Judica />} />
        <Route path="/hiring-agent" element={<HiringAgent />} />
        <Route path="/recruiting-agent" element={<RecruitingAgent />} />
        <Route path="/subscription-expired" element={<SubscriptionExpired />} />
        {/* Reports */}
        <Route path="/review-productivity" element={<ReviewProductivity />} />
        <Route path="/growth-agent" element={<GrowthAgent />} />
        {/* About */}
        <Route path="/about" element={<About />} />
        <Route path="/about/what-new" element={<WhatNew />} />
        {/* Demo-version */}
        <Route path="/permission" element={<Permission />} />
        <Route path="/report-dashboard" element={<ReportDashBoard />} />
        <Route path="/access-team-fit" element={<AccessTeamFit />} />
        <Route path="/access-team-fit/view" element={<AccessTeamFitView />} />
        <Route
          path="/access-team-fit/compare"
          element={<JigsawCandidateCompare />}
        />
        <Route
          path="/access-team-fit/create"
          element={<AccessTeamFitCreate />}
        />
        <Route
          path="/access-team-fit/create"
          element={<AccessTeamFitCreate />}
        />
        <Route path="/proposal-list" element={<ProposalTableList />} />
        <Route path="/bid-management" element={<BidManagement />} />
        <Route path="/proposal-generator-view" element={<StepperComponent />} />
        <Route
          path="/jobs/jobs-view/interview-kit"
          element={<InterviewKit />}
        />
      </Route>

      <Route path="/" element={<AuthLayout />}>
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
      </Route>

      <Route path="/" element={<FullLayout />}>
        {/* CoverSheet */}
        <Route path="/coversheet" element={<Coversheet />} />
        <Route path="/candidate-coversheet" element={<CoverSheetCandidate />} />
        <Route path="/resume/upload/:id" element={<ResumeUpload />} />
        {/* Reference Check */}
        <Route path="/reference/:id" element={<ReferenceCheckDetails />} />

        {/* login */}
        <Route
          path="/auth/login"
          element={
            <ProtectedRoute>
              <AuthLogin />
            </ProtectedRoute>
          }
        />
        <Route path="/auth/sign-up" element={<SignUp />} />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnBoarding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dynamic-intelligence/:id"
          element={<DynamicIntelligence />}
        />
        <Route
          path="/plan-expired"
          element={
            <ProtectedRoute>
              <PlanExpired />
            </ProtectedRoute>
          }
        />
        <Route path="/buy-credits" element={<BuyCredits />} />
        <Route path="/account-create" element={<AccountCreate />} />
        <Route path="/creation-failed" element={<CreateFailed />} />
        <Route path="/transaction-status" element={<TransactionStatus />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default MainRoutes;
